import { apiUtils, appConstants } from 'apis/common';
import { Quote } from 'defs/quote';

export async function quotesApi(token: number): Promise<Quote> {
  const resp = await apiUtils.callApi(appConstants.quotesUrl(token), 'GET', null);
  const data: Quote = resp.data?.payload;
  return data;
}
